import { component as defineComponent } from 'flightjs';
import trackEvent from '@99designs/common/utils/platform/trackEvent';

//
// Flight component for Segment event tracking.
//
// eg. Analytics.attachTo(document, {
//       namespace: "Some page",
//       events: {
//         "uiDoSomething": "Did something",
//         'uiRateSomething": "Entry rated"
//       }
//     });
//

export default defineComponent(function() {
    this.attributes({
        namespace: false,
        events: {},
    });

    this.buildEventName = function(e) {
        const name = this.attr.events[e.type] || e.type;
        if (this.attr.namespace) {
            return `${this.attr.namespace} ${name}`;
        } else {
            return name;
        }
    };

    this.trackEvent = function(e, data = {}) {
        trackEvent(this.buildEventName(e), data);
    };

    this.after('initialize', function() {
        Object.keys(this.attr.events).forEach((event, name) => {
            this.on(event, this.trackEvent);
        });
    });
});



// WEBPACK FOOTER //
// ./src/web/js/app/modules/data/analytics.js